import { Component, OnInit } from '@angular/core';
import { LogService } from '@app/_shared/log.service'

@Component({
  selector: 'app-verifier',
  templateUrl: './verifier.component.html',
  styleUrls: ['./verifier.component.less']
})
export class VerifierComponent implements OnInit {

  constructor( private eventService: LogService) { }


  callRoute(dataValue) {
    this.eventService.emit<string>(dataValue);
  }
  ngOnInit() {
    // callRoute();
  }

}
